import Constants from 'expo-constants';
import { Platform } from 'react-native';

const LOCALHOST_HOSTS = new Set(['localhost', '127.0.0.1']);

function getDevHost() {
  const hostUri =
    Constants.expoConfig?.hostUri ??
    (Constants as typeof Constants & { manifest2?: { extra?: { expoClient?: { hostUri?: string } } } })
      .manifest2?.extra?.expoClient?.hostUri ??
    (Constants as typeof Constants & { manifest?: { debuggerHost?: string } }).manifest?.debuggerHost;

  if (hostUri) {
    return hostUri.split(':')[0] ?? null;
  }

  const explicitHost = process.env['EXPO_PUBLIC_DEV_HOST'];
  if (explicitHost) {
    return explicitHost;
  }

  return null;
}

export function resolveDevelopmentUrl(url: string) {
  if (Platform.OS === 'web') {
    return url;
  }

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }

  if (!LOCALHOST_HOSTS.has(parsed.hostname)) {
    return url;
  }

  // iOS simulators can reach host-machine loopback services directly, and our
  // local Supabase stack binds to 127.0.0.1. Rewriting that URL to a LAN host
  // breaks auth/session bootstrap during native simulator runs.
  if (Platform.OS === 'ios' && parsed.hostname === '127.0.0.1') {
    return parsed.toString();
  }

  if (Platform.OS === 'android') {
    parsed.hostname = '10.0.2.2';
    return parsed.toString();
  }

  const devHost = getDevHost();
  if (!devHost) {
    return url;
  }

  parsed.hostname = devHost;
  return parsed.toString();
}
